export * from './baAppPicture.pipe';



// WEBPACK FOOTER //
// ./src/app/theme/pipes/baAppPicture/index.ts